import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";
import {
  addBrand,
  getBrand,
  getBrands,
  importBrand,
  updateBrand,
} from "./service";
import { useNavigate } from "react-router";

export const useGetBrands = (
  { keyword, page }: { keyword?: string; page: number } = {
    page: 1,
  }
) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: ["produkBrands", page, keyword],
    queryFn: () => getBrands({ keyword, page }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetBrand = ({
  product_brand_id,
}: {
  product_brand_id?: string;
}) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: product_brand_id !== undefined,
    queryKey: ["produkBrand", product_brand_id],
    queryFn: () => getBrand({ product_brand_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddBrand = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();

  return useMutation({
    mutationFn: ({ brand_name }: { brand_name: string }) =>
      addBrand({ brand_name }),
    onSuccess: (e) => showToast("Berhasil menambahkan brand baru"),
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdateBrand = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({
      brand_name,
      product_brand_id,
    }: {
      brand_name: string;
      product_brand_id: string;
    }) => updateBrand({ brand_name, product_brand_id }),
    onSuccess: (e) => {
      showToast("Berhasil update brand");
      navigate("/brand");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useImportBrand = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();

  return useMutation({
    mutationKey: ["importProductBrand"],
    mutationFn: ({ file }: { file: File }) => importBrand({ file }),
    onSuccess: (e) => showToast("Berhasil melakukan import brand produk"),
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
